import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { Installment } from 'src/app/core/models/Installment';
import { InstallmentService } from 'src/app/services/installment.service';

@Component({
  selector: 'app-installment-form',
  templateUrl: './installment-form.component.html',
  styleUrls: ['./installment-form.component.css'],
})
export class InstallmentFormComponent implements OnInit {
  @Input() installmentToEdit?: Installment;

  @Output() closeAction = new EventEmitter();

  installmentFormGroup = new UntypedFormGroup({
    amount: new UntypedFormControl('', [
      Validators.required,
      Validators.min(0),
      Validators.max(2147483647),
    ]),
  });

  constructor(private installmentService: InstallmentService) {}

  ngOnInit() {
    console.log(this.installmentToEdit);
    this.installmentFormGroup.patchValue({
      amount: this.installmentToEdit.amount,
    });
  }

  onSubmit() {
    if (this.installmentFormGroup.invalid) {
      return;
    }

    const newAmount = parseFloat(this.installmentFormGroup.value.amount);
    
    const formatDate = (date: any): string => {
      if (!date) return null;
      if (date instanceof Date) {
        return date.toISOString();
      }
      if (typeof date === 'string') {
        return date;
      }
      return null;
    };

    const installmentForEdit = {
      number: this.installmentToEdit.number || 0,
      amount: newAmount,
      amountPaid: this.installmentToEdit.amountPaid || 0,
      debt: this.installmentToEdit.debt ?? null,
      fromDate: formatDate(this.installmentToEdit.fromDate),
      endDate: formatDate(this.installmentToEdit.endDate),
      expirationDate: formatDate(this.installmentToEdit.expirationDate),
      details: this.installmentToEdit.details || '',
      installmentsQuantity: this.installmentToEdit.installmentsQuantity || 0,
      expirationDay: this.installmentToEdit.expirationDay || 0,
      expirationIncrease: this.installmentToEdit.expirationIncrease || 0,
      paymentId: 0,
      agency: null,
      agencyId: this.installmentToEdit.agencyId || 0,
      description: this.installmentToEdit.description || '',
      hasInVoice: this.installmentToEdit.hasInVoice || false,
      restriction: this.installmentToEdit.restriction || null,
      contractId: this.installmentToEdit.contractId,
      surcharge: null,
      installmentType: null,
      installmentTypeId: this.installmentToEdit.installmentTypeId || 0,
      installmentGenerationTypes: null,
      installmentGenerationTypeId: this.installmentToEdit.installmentGenerationTypeId || 0,
      installmentStatus: null,
      installmentStatusId: this.installmentToEdit.installmentStatusId || 0,
      additionalCharges: (this.installmentToEdit.additionalCharges || []).map(charge => ({
        id: charge.id || 0,
        detail: charge.detail || '',
        amount: charge.amount || 0,
        sign: charge.sign !== undefined ? charge.sign : true,
        installmentId: charge.installmentId || this.installmentToEdit.id,
        punitive: charge.punitive || false
      }))
    };

    console.log('🔍 Enviando DTO al backend:', {
      installmentId: this.installmentToEdit.id,
      oldAmount: this.installmentToEdit.amount,
      newAmount: newAmount,
      dto: installmentForEdit
    });

    this.installmentService
      .editInstallment(installmentForEdit, this.installmentToEdit.id)
      .subscribe({
        next: (response) => {
          console.log('✅ Respuesta del backend:', response);
          // Actualizar el objeto local con el nuevo monto
          this.installmentToEdit.amount = newAmount;
          this.closeAction.emit();
        },
        error: (error) => {
          console.error('❌ Error al editar la cuota:', error);
          console.error('Error completo:', JSON.stringify(error, null, 2));
        }
      });
  }
}
